"use strict";
var TimerObservable_1 = require('./TimerObservable');
exports.timer = TimerObservable_1.TimerObservable.create;
//# sourceMappingURL=timer.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/~/rxjs/observable/timer.js
// module id = ../../../../rxjs/observable/timer.js
// module chunks = 4